import { Record, Map as ImmutableMap } from 'immutable';
import PropertyValue from 'automation-ui-flow-core/fields/PropertyValue';
export default class PropertyAssignment extends Record({
  targetProperty: null,
  value: null
}, 'PropertyAssignment') {
  constructor(props) {
    const propMap = ImmutableMap(props);
    super(propMap.set('value', new PropertyValue(propMap.get('value') || {})));
  }
}